import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { RuntimeService } from '../../shared/services/runtime.service';

export const AuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const runtime = inject(RuntimeService);
  const router = inject(Router);

  if (authService.isMfaPending()) {
    return router.createUrlTree(['/authenticate']);
  }

  if (!authService.isLoggedIn()) {
    if (runtime.IsDesktopApplication && !authService.hasLicence()) {
      return router.createUrlTree(['/verify-licence']);
    }
    return router.createUrlTree(['/login']);
  }

  return true;
};
